import React, { useState, useEffect } from 'react';
import { getEmailPreferences, setEmailPreferences } from '../../services/auth';

export const EmailPreferences: React.FC = () => {
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    getEmailPreferences()
      .then((data) => setEnabled(data.weekly_report_enabled))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const handleToggle = async () => {
    setSaving(true);
    try {
      const newValue = !enabled;
      await setEmailPreferences({ weekly_report_enabled: newValue });
      setEnabled(newValue);
    } catch (err) {
      console.error('Failed to update preferences:', err);
    } finally {
      setSaving(false);
    }
  };

  if (loading) return null;

  return (
    <div className="email-preferences">
      <div className="pref-row">
        <div className="pref-info">
          <span className="pref-label">Weekly Email Reports</span>
          <span className="pref-description">
            Receive a weekly summary of your children's progress by email.
          </span>
        </div>
        <label className="toggle-switch">
          <input
            type="checkbox"
            checked={enabled}
            onChange={handleToggle}
            disabled={saving}
          />
          <span className="toggle-slider" />
        </label>
      </div>
    </div>
  );
};
